import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/serviexpress-vial-logo.png`;

const BrandLogo = ({ compact = false, variant = 'default', className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const toneClass =
    variant === 'dark'
      ? 'opacity-85 mix-blend-screen saturate-125 contrast-110'
      : 'opacity-100';

  if (hasError) {
    return (
      <div
        className={`flex items-center justify-center rounded-xl bg-gradient-to-br from-primary to-accent shadow-lg ${compact ? 'h-10 w-10' : 'h-16 w-16'} ${className}`}
      >
        <Sparkles className={`${compact ? 'h-5 w-5' : 'h-8 w-8'} text-white`} />
      </div>
    );
  }

  return (
    <img
      src={LOGO_SRC}
      alt="Serviexpress Vial"
      onLoad={() => setHasError(false)}
      onError={() => setHasError(true)}
      className={`${compact ? 'h-10 w-10' : 'h-24 w-auto'} object-contain ${toneClass} ${className}`}
    />
  );
};

export default BrandLogo;
